export const GERAL_VALUE = 'geral';

export const PARTNER_OPTIONS_DEFAULT: Array<{ value: string; label: string }> = [
  { value: GERAL_VALUE, label: 'Geral' },
];
